import { createTheme } from '@mui/material/styles';
import theme from 'shared/themes/default';

// Extend MUI's TypographyVariants to include custom variants
declare module '@mui/material/styles' {
  interface TypographyVariants {
    helperText: React.CSSProperties;
    helperTextS: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    helperText?: React.CSSProperties;
    helperTextS?: React.CSSProperties;
  }
  interface BreakpointOverrides {
    mobile: true;
    tablet: true;
    desktop: true;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    helperText: true;
    helperTextS: true;
  }
}

const vcMuiTheme = createTheme({
  typography: {
    fontFamily: theme.fonts.primary,
    h1: {
      fontSize: '3rem',
      fontWeight: 400,
      lineHeight: '117%',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 400,
      lineHeight: '122%',
    },
    h3: {
      fontSize: '2.25rem',
      fontWeight: 400,
      lineHeight: '122%',
    },
    h4: {
      fontSize: '1.875rem',
      fontWeight: 400,
      lineHeight: '125%',
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: '135%',
    },
    subtitle1: {
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: '140%',
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '140%',
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '140%',
    },
    helperText: {
      fontFamily: theme.fonts.primary,
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: '135%',
    },
    helperTextS: {
      fontFamily: theme.fonts.primary,
      fontSize: '0.625rem',
      fontWeight: 400,
      lineHeight: '140%',
    },
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: theme.fonts.primary,
        },
      },
    },
    MuiGrid: {
      defaultProps: {
        columns: {
          mobile: 4,
          tablet: 6,
          desktop: 8,
        },
        spacing: 1,
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      mobile: 0,
      tablet: 768,
      desktop: 1024,
    },
  },
});

export default vcMuiTheme;
